import React from 'react';
import { motion } from 'framer-motion';
import { FamilyMember } from '../../data/family';
interface MemberNodeProps {
  member: FamilyMember;
  isSelected: boolean;
  onClick: () => void;
}
export function MemberNode({
  member,
  isSelected,
  onClick
}: MemberNodeProps) {
  // Staggered float animation based on ID so they don't all bob together
  const floatDelay = parseInt(member.id) * 0.2;
  return <motion.div className="absolute z-20 cursor-pointer" style={{
    left: member.x,
    top: member.y,
    x: '-50%',
    y: '-50%'
  }} animate={{
    y: ['-50%', `calc(-50% - 8px)`, '-50%']
  }} transition={{
    repeat: Infinity,
    duration: 4,
    delay: floatDelay,
    ease: 'easeInOut'
  }} onClick={onClick} data-id="element-123">
      <div className="relative flex flex-col items-center group" data-id="element-124">
        {/* Glow Ring */}
        <motion.div className="absolute inset-0 rounded-full bg-warm-cyan" initial={false} animate={{
        scale: isSelected ? 1.15 : 1,
        opacity: isSelected ? 0.4 : 0,
        filter: isSelected ? 'blur(12px)' : 'blur(0px)'
      }} transition={{
        duration: 0.3
      }} data-id="element-125" />

        {/* Avatar */}
        <motion.div className={`relative w-24 h-24 rounded-full overflow-hidden border-4 transition-colors duration-300 ${isSelected ? 'border-warm-cyan' : 'border-warm-border group-hover:border-warm-muted'}`} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} data-id="element-126">
          <img src={member.avatar} alt={member.name} className="w-full h-full object-cover" draggable={false} data-id="element-127" />
        </motion.div>

        {/* Label */}
        <div className="mt-3 bg-warm-surface/90 backdrop-blur-sm border border-warm-border px-4 py-1.5 rounded-full shadow-warm text-center whitespace-nowrap" data-id="element-128">
          <p className="font-serif text-warm-text text-sm" data-id="element-129">{member.name}</p>
          <p className="text-xs text-warm-muted font-mono" data-id="element-130">
            {member.birthYear}
          </p>
        </div>
      </div>
    </motion.div>;
}